package com.sweetlime.bingeamigo.presentation.features.tvdetail

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.SeasonDetail
import com.sweetlime.bingeamigo.repository.TmdbRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class SeasonDetailState {
    data object Loading : SeasonDetailState()
    data class Success(val seasonDetail: SeasonDetail) : SeasonDetailState()
    data class Error(val message: String) : SeasonDetailState()
}

class SeasonDetailViewModel(
    private val repository: TmdbRepository
) : ViewModel() {

    private val _state = MutableStateFlow<SeasonDetailState>(SeasonDetailState.Loading)
    val state: StateFlow<SeasonDetailState> = _state.asStateFlow()

    fun load(tvShowId: Int, seasonNumber: Int) {
        _state.value = SeasonDetailState.Loading
        viewModelScope.launch {
            val detail = repository.getSeasonDetail(tvShowId, seasonNumber)
            _state.value = if (detail != null) {
                SeasonDetailState.Success(detail)
            } else {
                SeasonDetailState.Error("Failed to load season details")
            }
        }
    }
}
